// Update password
export const loadingOpen = 'loadingOpen';
export const loadingClose = 'loadingClose';